exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_loginContent__1DKER {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  height: 100%;\n}\n\n.styles_loginTitle__2Z64V {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  height: 100%;\n}\n\n", ""]);

// Exports
exports.locals = {
	"loginContent": "styles_loginContent__1DKER",
	"loginTitle": "styles_loginTitle__2Z64V"
};